import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './TabbedPageControl.scss';

TabbedPageControl.propTypes = {
  tabItems: PropTypes.arrayOf(PropTypes.string),
  selectedTabName: PropTypes.string,
  selectedTabPath: PropTypes.string,
  handleClick: PropTypes.func,
  /** Optional map of tab value -> label text (e.g. { documents: 'projects' } shows PROJECTS) */
  tabLabelOverrides: PropTypes.object,
};

export default function TabbedPageControl(props) {
  const dashboardTabs = ['dashboard', 'project reporting', 'project analysis', 'user reporting', 'activity log'];
  const { selectedTabName, tabItems, handleClick, selectedTabPath, tabLabelOverrides } = props;
  if (!tabItems) {
    return null;
  }
  const tabs = tabItems.map((tabName, index) => {
    const isSelected = tabName == (selectedTabPath?selectedTabPath:selectedTabName);
    const isDisabled = props.disabledItems ? props.disabledItems.find(disabledTabName => { return disabledTabName == tabName;}) : false;
    const gotoRoute = tabName.replace(' ','-');
    const overrideLabel = tabLabelOverrides && tabLabelOverrides[tabName] != null ? String(tabLabelOverrides[tabName]) : null;
    const defaultUpper = tabName.toUpperCase() == 'SUMMARY' ? 'PROJECTS' : tabName.toUpperCase();
    const tabDisplayText = overrideLabel != null ? overrideLabel.toUpperCase() : defaultUpper;
    return (
      <div key={index} className={'tab' + (isSelected ? ' selected' : '') + (isDisabled ? ' disabled' : '')} onClick={() => { !isDisabled && handleClick(tabName); }}>
        <div className={'tab-label' + (isSelected ? ' selected' : '') + (isDisabled ? ' disabled' : '')}>
          {dashboardTabs.includes(tabName)
          ? <Link key={index} className='link' to={'/manager-dashboard/'+gotoRoute}>
              {tabName.toUpperCase() == 'SUMMARY' ? 'PROJECTS' : tabName.toUpperCase()}
            </Link>
          : tabDisplayText}
        </div>
      </div>
    );
  });
  return (
      <div className={'tab-array' + (props.borderTop ? ' border-top' : '')}>
        {tabs}
      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/TabbedPageControl/index.js